module.exports = __webpack_public_path__ + "img/des_guzheng_2.4dcced73.jpg";